import { useTranslations } from '@aikoa/i18n/react'
import { useGlobalSearchParams, useRouter } from 'expo-router'
import { useCallback } from 'react'
import { EventForm, type EventFormData } from '~/components/events/EventForm'
import ScreenView from '~/components/layout/ScreenView'
import { useCreateEvent } from '~/data/events/useEvents'

export default function AddEventPage() {
  const { t } = useTranslations('property')
  const router = useRouter()
  const { assetId } = useGlobalSearchParams<{ assetId: string }>()
  const { mutate: createEvent, isPending } = useCreateEvent()

  const handleSubmit = useCallback(
    (data: EventFormData) => {
      if (!assetId) {
        return
      }

      createEvent(
        {
          assetId,
          title: data.title,
          description: data.description || null,
          eventType: data.eventType,
          eventDate: data.eventDate,
        },
        {
          onSuccess: (event) => {
            if (event) {
              router.replace(`/(authenticated)/events/${event.id}`)
            } else {
              router.replace(`/(authenticated)/property/${assetId}`)
            }
          },
        }
      )
    },
    [assetId, createEvent, router]
  )

  const handleCancel = useCallback(() => {
    if (assetId) {
      router.replace(`/(authenticated)/property/${assetId}`)
    } else {
      router.back()
    }
  }, [assetId, router])

  return (
    <ScreenView>
      <EventForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isSubmitting={isPending}
        submitLabel={t(($) => $.events.create)}
      />
    </ScreenView>
  )
}
